import * as XLSX from 'xlsx';
import {reactHtmlTableToExcel} from './reactHtmlTableToExcel';

export const exportJsonToExcel = (e, props) => {
  e.preventDefault();
  const {data, fileName, ext} = props;
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Hoja 1');
  XLSX.writeFile(wb, `${fileName}.${ext}`);
};

export function exportHtmlTableToExcel(tableId, sheetName, fileName) {
  reactHtmlTableToExcel(tableId, sheetName, fileName);
}
